@if (target === '_self') {
  @if (href) {
    <a
      [ngClass]="classes"
      [routerLink]="href"
      [title]="title"
    >
      <ng-container *ngTemplateOutlet="linkTemplate"></ng-container>
    </a>
  }

  @if (!href) {
    <a
      [ngClass]="classes"
      href="#"
      (click)="onClick()"
      [title]="title"
    >
      <ng-container *ngTemplateOutlet="linkTemplate"></ng-container>
    </a>
  }
}

@if (target !== '_self') {
  <a
    [ngClass]="classes"
    [href]="href"
    [target]="target"
    [title]="title"
    rel="noreferrer"
  >
    <ng-container *ngTemplateOutlet="linkTemplate"></ng-container>
  </a>
}

<ng-template #linkTemplate>
  <ng-content></ng-content>
</ng-template>